import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import StringInput from './stringInput';
import DateInput from './dates/dateInput';
import Selector from './selector';
import NumberInput from './numberInput';
import { ItemPicker, foreignPropType } from '../itemField';

function UnknowTypeComponent() {
  return <span style={{ color: 'red' }}>Невідомий тип параметру</span>;
}

const MultiVaueInput = forwardRef(({
  value, disabled, readOnly,
  onClick, onFocus, onChange, id,
  ctype, resource,
  errored, margin,

}, ref) => {
  const ParamsComponent = useMemo(() => {
    if (ctype === 'String') {
      return StringInput;
    }
    if (ctype === 'Date') {
      return DateInput;
    }
    if (ctype === 'Boolean') {
      return Selector;
    }
    if (ctype === 'Integer') {
      return NumberInput;
    }
    if (ctype === 'Decimal') {
      return NumberInput;
    }
    if (ctype === 'NestedObject' && resource) {
      // eslint-disable-next-line import/no-cycle
      return ItemPicker;
    }
    return UnknowTypeComponent;
  }, [ctype, resource]);

  const fcProps = useMemo(() => {
    const globalProps = {
      id,
      value,
      onChange,
      disabled,
      readOnly,
      onClick,
      onFocus,
      errored,
    };
    if (ctype === 'Boolean') {
      return {
        ...globalProps,
        values: [
          { value: true, display_name: 'Так' },
          { value: false, display_name: 'Ні' },
        ],
      };
    }
    if (ctype === 'Date') {
      return {
        ...globalProps,
        variants: [
          { value: '@today', display_name: 'Сьогодні' },
          { value: '@yesterday', display_name: 'Вчора' },
          { value: '@tomorrow', display_name: 'Завтра' },
          { value: '@begin_of_the_year', display_name: 'Початок цього року' },
          { value: '@end_of_the_year', display_name: 'Кінець цього року' },
        ],
      };
    }
    if (ctype === 'Integer') {
      return {
        ...globalProps,
        precision: 0,
      };
    }
    if (ctype === 'Decimal') {
      return {
        ...globalProps,
        precision: 2,
      };
    }
    if (ctype === 'NestedObject' && resource) {
      return {
        ...globalProps,
        backend: resource,
        canErase: true,
      };
    }
    return globalProps;
  }, [ctype, disabled, errored, id, onChange, onClick, onFocus, readOnly, resource, value]);

  return (
    <ParamsComponent
      ref={ref}
      margin={margin}
      {...fcProps}
    />
  );
});

MultiVaueInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string, PropTypes.bool, PropTypes.number, foreignPropType,
  ]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  errored: PropTypes.bool,
  ctype: PropTypes.oneOf(['String', 'Date', 'Boolean', 'Integer', 'Decimal', 'NestedObject']).isRequired,
  resource: PropTypes.string,
  margin: PropTypes.oneOf(['none', 'normal', 'dense']),
};

MultiVaueInput.defaultProps = {
  value: null,
  disabled: false,
  readOnly: false,
  onClick: null,
  onFocus: null,
  errored: false,
  resource: null,
  margin: 'dense',
};

export default MultiVaueInput;
